import React from "react";
import { Button, MenuButton } from "@chakra-ui/react";
import { Export } from "components";
import { useCurrentCase } from "duck";

interface ExportProps {
  disabled: boolean;
}

const ExportCase: React.FC<ExportProps> = ({ disabled }) => {
  const { isVetspireCase, caseId } = useCurrentCase(({ data }) => ({
    isVetspireCase: data.fromVetspire,
    caseId: data._id
  }));

  return (
    <Export
      caseId={caseId}
      isVetspireCase={isVetspireCase}
      menuButton={
        <MenuButton
          as={Button}
          size="sm"
          colorScheme="minor"
          isDisabled={disabled}
        >
          Export
        </MenuButton>
      }
    />
  );
};

export default ExportCase;
